// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner__spinner__jvUtq"};